module.exports = __webpack_public_path__ + "img/Team-Wilde-Pracht-860.7b3ac457.jpg";